var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 141.313,
    height: 49.561,
    viewBox: "0 0 141.313 49.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M0-24.09H141.313V-73.651H0Z",
    transform: "translate(0 73.651)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600",
    transform: "translate(0 73.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(0 -73.651)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469",
    transform: "translate(32.3 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M0-.981A2.019,2.019,0,0,1,2.019-3H11.44A2.019,2.019,0,0,1,13.458-.981V27.281A2.019,2.019,0,0,1,11.44,29.3H2.019A2.019,2.019,0,0,1,0,27.281Z",
    transform: "translate(0 3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    transform: "translate(16.15 9.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M0-.981A2.019,2.019,0,0,1,2.019-3H11.44A2.019,2.019,0,0,1,13.458-.981V17.86a2.019,2.019,0,0,1-2.019,2.019H2.019A2.019,2.019,0,0,1,0,17.86Z",
    transform: "translate(0 3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471",
    transform: "translate(0 18.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M0-.981A2.019,2.019,0,0,1,2.019-3H11.44A2.019,2.019,0,0,1,13.458-.981V8.44a2.019,2.019,0,0,1-2.019,2.019H2.019A2.019,2.019,0,0,1,0,8.44Z",
    transform: "translate(0 3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472",
    transform: "translate(54.41 5.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M-2.268-5.763c3.275,0,4.863-1.638,4.863-3.554,0-4.208-6.665-2.751-6.665-4.863,0-.721.606-1.31,2.178-1.31a6.472,6.472,0,0,1,3.177.9L2.1-16.6a7.692,7.692,0,0,0-3.979-1.015c-3.259,0-4.831,1.621-4.831,3.57,0,4.258,6.665,2.783,6.665,4.928,0,.7-.639,1.228-2.211,1.228a6.744,6.744,0,0,1-3.782-1.2l-.9,2A8.169,8.169,0,0,0-2.268-5.763",
    transform: "translate(6.935 17.618)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(65.037 5.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M-3.017-5.763A5.89,5.89,0,0,0,1.716-7.81L.013-9.381A3.655,3.655,0,0,1-2.869-8.022,3.516,3.516,0,0,1-6.537-11.69a3.516,3.516,0,0,1,3.668-3.668A3.689,3.689,0,0,1,.013-14.016l1.7-1.572A5.917,5.917,0,0,0-3-17.618,5.889,5.889,0,0,0-9.223-11.69,5.885,5.885,0,0,0-3.017-5.763",
    transform: "translate(9.223 17.618)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475",
    transform: "translate(76.025 -67.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M-2.229-3.4-.411-7.787,1.406-3.4Zm5.486,4.47H6.041L.915-10.391H-1.7L-6.814,1.071H-4.1L-3.08-1.385H2.241Z",
    transform: "translate(6.814 10.391)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476",
    transform: "translate(90.075 -67.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M0-5.572H8.4V-7.733H2.653v-9.3H0Z",
    transform: "translate(0 17.034)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477",
    transform: "translate(99.966 -67.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M-1.282-4.537V-7.19H4.041V-9.253H-1.282v-2.489H4.744v-2.129H-3.918V-2.409H4.957V-4.537Z",
    transform: "translate(3.918 13.871)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480",
    transform: "translate(0 -73.651)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478",
    transform: "translate(110.855 6.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M-2.523-5.667c3.259,0,5.191-1.867,5.191-5.24v-6.419H.048v6.321c0,2.178-.934,3.079-2.555,3.079-1.6,0-2.554-.9-2.554-3.079v-6.321H-7.714v6.419c0,3.373,1.932,5.24,5.191,5.24",
    transform: "translate(7.714 17.326)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479",
    transform: "translate(123.857 6.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M-2.34-2.985H-4.5V-6.964H-2.34c1.621,0,2.44.737,2.44,2,0,1.244-.819,1.981-2.44,1.981m.147-6.14H-7.154V2.337H-4.5V-.823h2.309c3.062,0,4.978-1.588,4.978-4.142,0-2.571-1.916-4.159-4.978-4.159",
    transform: "translate(7.154 9.125)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M82.195-31.195h2.653V-42.657H82.195Z",
    transform: "translate(-26.885 -10.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481",
    transform: "translate(60.682 -52.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M-3.836,0V6.959L-9.535,0h-2.194V11.462h2.62V4.5l5.715,6.959h2.178V0Z",
    transform: "translate(11.729)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483",
    transform: "translate(0 -73.651)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482",
    transform: "translate(73.012 20.66)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M-2.268-5.763c3.275,0,4.863-1.638,4.863-3.554,0-4.208-6.665-2.751-6.665-4.863,0-.721.606-1.31,2.178-1.31a6.472,6.472,0,0,1,3.177.9L2.1-16.6a7.686,7.686,0,0,0-3.979-1.015c-3.259,0-4.831,1.621-4.831,3.57,0,4.258,6.665,2.784,6.665,4.928,0,.7-.639,1.228-2.211,1.228a6.744,6.744,0,0,1-3.782-1.2l-.9,2A8.169,8.169,0,0,0-2.268-5.763",
    transform: "translate(6.935 17.618)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484",
    transform: "translate(82.903 -52.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M-1.783-5.572H.87v-9.3H4.538v-2.161H-5.451v2.161h3.668Z",
    transform: "translate(5.451 17.034)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M140.16-31.195h2.653V-42.657H140.16Z",
    transform: "translate(-45.844 -10.138)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    transform: "translate(98.394 -52.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M-1.783-5.572H.87v-9.3H4.538v-2.161H-5.451v2.161h3.668Z",
    transform: "translate(5.451 17.034)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487",
    transform: "translate(0 -73.651)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486",
    transform: "translate(109.512 20.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M-2.523-5.667c3.259,0,5.191-1.867,5.191-5.24v-6.419H.048v6.321c0,2.178-.934,3.079-2.555,3.079-1.6,0-2.554-.9-2.554-3.079v-6.321H-7.714v6.419c0,3.373,1.932,5.24,5.191,5.24",
    transform: "translate(7.714 17.326)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488",
    transform: "translate(121.024 -52.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M-1.783-5.572H.87v-9.3H4.538v-2.161H-5.451v2.161h3.668Z",
    transform: "translate(5.451 17.034)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489",
    transform: "translate(132.438 -52.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M0,0V11.462H8.875V9.334H2.636V6.681H7.958V4.618H2.636V2.128H8.662V0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492",
    transform: "translate(0 -73.651)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490",
    transform: "translate(0 43.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M-.391-2.394V-6.619H1.128A2.072,2.072,0,0,1,3.409-4.507,2.073,2.073,0,0,1,1.128-2.394Zm-.8.7h2.37A2.784,2.784,0,0,0,4.212-4.507,2.784,2.784,0,0,0,1.176-7.318h-2.37Z",
    transform: "translate(1.194 7.318)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491",
    transform: "translate(6.957 43.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M-1.054-1.57H-2.42V-4.1h1.365C-.026-4.1.512-3.642.512-2.839S-.026-1.57-1.054-1.57M1.412.825.078-1.064A1.775,1.775,0,0,0,1.316-2.839C1.316-4.06.432-4.8-1.03-4.8H-3.223V.825h.8V-.887h1.39c.12,0,.241-.008.353-.016L.537.825Z",
    transform: "translate(3.223 4.799)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M19.5-2.828h.8V-8.452h-.8Z",
    transform: "translate(-6.376 -21.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493",
    transform: "translate(15.022 -29.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M-2.4,0l-2.04,4.619L-6.463,0h-.868l2.475,5.624h.8L-1.6,0Z",
    transform: "translate(7.331)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M32.387-2.828h.8V-8.452h-.8Z",
    transform: "translate(-10.593 -21.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494",
    transform: "translate(24.606 -29.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M-1.96,0V4.194L-5.334,0h-.659V5.624h.8V1.43l3.374,4.194h.659V0Z",
    transform: "translate(5.993)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497",
    transform: "translate(0 -73.651)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495",
    transform: "translate(30.993 43.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M-2.116-2.273a2.379,2.379,0,0,1-1.318.361A2.135,2.135,0,0,1-5.667-4.072,2.128,2.128,0,0,1-3.426-6.233a2.23,2.23,0,0,1,1.631.651l.5-.5a2.819,2.819,0,0,0-2.161-.868A2.853,2.853,0,0,0-6.47-4.072a2.849,2.849,0,0,0,3,2.876,3.326,3.326,0,0,0,2.129-.715V-4.1h-.771Z",
    transform: "translate(6.47 6.948)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496",
    transform: "translate(40.407 43.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M-1.156-2.765a2.207,2.207,0,0,0,2.378-2.49v-3.2H.443v3.165c0,1.246-.579,1.807-1.591,1.807s-1.583-.562-1.583-1.807V-8.452h-.8v3.2a2.211,2.211,0,0,0,2.378,2.49",
    transform: "translate(3.534 8.452)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498",
    transform: "translate(47.131 -29.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M-1.874,0-4.927,3.141V0h-.8V5.624h.8V4.169L-3.9,3.125l2.153,2.5h.94L-3.361,2.53-.958,0Z",
    transform: "translate(5.73)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502",
    transform: "translate(0 -73.651)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499",
    transform: "translate(55.711 43.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M-1.288-2.417H-3.136V-4.288h1.848C-.4-4.288.085-4,.085-3.349s-.482.932-1.373.932m-.2-4.322c.819,0,1.285.306,1.285.9s-.466.9-1.285.9H-3.136v-1.8ZM-.156-4.682A1.333,1.333,0,0,0,.6-5.935c0-.908-.723-1.454-2.016-1.454H-3.939v5.623h2.683C.166-1.766.9-2.321.9-3.284a1.359,1.359,0,0,0-1.052-1.4",
    transform: "translate(3.939 7.389)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500",
    transform: "translate(62.065 43.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M-1.156-2.765a2.207,2.207,0,0,0,2.378-2.49v-3.2H.443v3.165c0,1.246-.579,1.807-1.591,1.807s-1.583-.562-1.583-1.807V-8.452h-.8v3.2a2.211,2.211,0,0,0,2.378,2.49",
    transform: "translate(3.534 8.452)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501",
    transform: "translate(68.275 43.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M-1.046-2.8c1.486,0,2.177-.739,2.177-1.6,0-2.065-3.406-1.205-3.406-2.579,0-.49.409-.892,1.365-.892a2.907,2.907,0,0,1,1.542.458L.9-8.05a3.31,3.31,0,0,0-1.807-.5c-1.478,0-2.153.74-2.153,1.607C-3.062-4.852.343-5.72.343-4.346c0,.49-.418.867-1.39.867A2.9,2.9,0,0,1-2.9-4.13l-.3.626A3.336,3.336,0,0,0-1.046-2.8",
    transform: "translate(3.199 8.548)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M110.116-2.828h.8V-8.452h-.8Z",
    transform: "translate(-36.017 -21.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503",
    transform: "translate(76.91 -29.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M-1.96,0V4.194L-5.334,0h-.659V5.624h.8V1.43l3.374,4.194h.658V0Z",
    transform: "translate(5.993)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504",
    transform: "translate(83.754 -29.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M0,0V5.624H4.081v-.7H.8V3.109h2.82V2.426H.8V.7H3.969V0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    transform: "translate(0 -73.651)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505",
    transform: "translate(88.944 43.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M-1.046-2.8c1.486,0,2.177-.739,2.177-1.6,0-2.065-3.406-1.205-3.406-2.579,0-.49.409-.892,1.365-.892a2.907,2.907,0,0,1,1.542.458L.9-8.05a3.31,3.31,0,0,0-1.807-.5c-1.478,0-2.153.74-2.153,1.607C-3.062-4.852.343-5.72.343-4.346c0,.49-.418.867-1.39.867A2.9,2.9,0,0,1-2.9-4.13l-.3.626A3.336,3.336,0,0,0-1.046-2.8",
    transform: "translate(3.199 8.548)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506",
    transform: "translate(94.254 43.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M-1.046-2.8c1.486,0,2.177-.739,2.177-1.6,0-2.065-3.406-1.205-3.406-2.579,0-.49.41-.892,1.366-.892a2.907,2.907,0,0,1,1.542.458L.9-8.05a3.31,3.31,0,0,0-1.807-.5c-1.478,0-2.153.74-2.153,1.607C-3.062-4.852.343-5.72.343-4.346c0,.49-.418.867-1.39.867A2.9,2.9,0,0,1-2.9-4.13l-.3.626A3.336,3.336,0,0,0-1.046-2.8",
    transform: "translate(3.199 8.548)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507",
    transform: "translate(102.103 43.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M-2.116-2.273a2.379,2.379,0,0,1-1.318.361A2.135,2.135,0,0,1-5.667-4.072,2.128,2.128,0,0,1-3.426-6.233a2.23,2.23,0,0,1,1.631.651l.5-.5a2.819,2.819,0,0,0-2.161-.868A2.853,2.853,0,0,0-6.47-4.072a2.849,2.849,0,0,0,3,2.876,3.326,3.326,0,0,0,2.129-.715V-4.1h-.771Z",
    transform: "translate(6.47 6.948)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508",
    transform: "translate(109.084 43.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M-1.054-1.57H-2.42V-4.1h1.365C-.026-4.1.512-3.642.512-2.839S-.026-1.57-1.054-1.57M1.412.825.078-1.064A1.775,1.775,0,0,0,1.316-2.839C1.316-4.06.432-4.8-1.03-4.8H-3.223V.825h.8V-.887h1.39c.12,0,.241-.008.353-.016L.537.825Z",
    transform: "translate(3.223 4.799)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509",
    transform: "translate(114.787 43.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M-1.456-2.448A2.115,2.115,0,0,1-3.65-4.609,2.115,2.115,0,0,1-1.456-6.77,2.111,2.111,0,0,1,.72-4.609,2.111,2.111,0,0,1-1.456-2.448m0,.715a2.849,2.849,0,0,0,2.98-2.876,2.849,2.849,0,0,0-2.98-2.876,2.858,2.858,0,0,0-3,2.876,2.858,2.858,0,0,0,3,2.876",
    transform: "translate(4.453 7.485)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511",
    transform: "translate(121.551 -29.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M-3.776,0l-1.55,4.595L-6.877,0h-.74L-9.2,4.57-10.717,0h-.827l1.879,5.624h.859L-7.27,1.133l1.534,4.491h.843L-3.013,0Z",
    transform: "translate(11.544)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512",
    transform: "translate(130.629 -29.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M0,0V.7H1.928V5.624h.795V.7H4.651V0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    transform: "translate(136.477 -29.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M-1.96,0V2.418H-5.19V0h-.8V5.624h.8V3.116H-1.96V5.624h.8V0Z",
    transform: "translate(5.993)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M0-16.524H141.313V-17.1H0Z",
    transform: "translate(0 -18.497)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6a1237f77b3fb054fed00530c76ba012.svg";
export { ForwardRef as ReactComponent };